import {
  Button,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";
import WhatsAppButton from "../../../Components/CluppForms/WhatsappButton";
import { Share, WhatsApp } from "@mui/icons-material";
import CluppDropdown from "../../../Components/CluppForms/CluppDropdown";
import { Link } from "react-router-dom";

const ReferedProgram = ({ state, setState }) => {
  const shareData = {
    title: "Seguro de movilidad Clupp",
    text: "Te invito a contratar tu seguro con Clupp",
    url: state.referURL,
  };
  const canShare = navigator.canShare && navigator.canShare(shareData);
  function handleShare() {
    if (canShare) {
      // open the native share menu
      return navigator.share(shareData);
    }
    // redirect to WhatsApp
    window.open(
      `https://wa.me/?text=${shareData.text} \n\n${shareData.url}`,
      "_blank"
    );
  }
  return (
    <>
      <TitleHeaders title={"Refiere y gana con Clupp 🎉"} />
      <Stack spacing={2}>
        <Typography variant="subtitle1" style={{ userSelect: "none" }}>
          Cuéntales a todos sobre Clupp y gana hasta <strong>$1,200</strong> por
          cada persona que proteja su vehículo y/o gadgets con nosotros. <br />
        </Typography>
        <CluppDropdown
          title={"Pasos para refefir"}
          startIcon={<Typography sx={{ fontSize: "20px" }}>📝</Typography>}
          description={
            <List sx={{ mt: 2 }}>
              <ListItem>
                <ListItemText
                  primary={
                    <>
                      1. Comparte el código QR o{" "}
                      <span
                        onClick={handleShare}
                        style={{
                          textDecoration: "underline",
                          color: "blueviolet",
                        }}
                      >
                        liga
                      </span>
                      , recuerda que es única para ti.
                    </>
                  }
                />
              </ListItem>
              <ListItem>
                <ListItemText primary="2. Una vez que contrate tu referido, te llegará un correo por haber referido." />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={
                    <>
                      3. Escribe por WhatsApp al 5577460177 dando clic{" "}
                      <Link
                        href={`https://wa.me/5215577460177?text=Hola,%20escribo%20para%20solicitar%20mi%20cup%C3%B3n%20por%20haber%20referido.%20Mi%20correo%20es%20${state.email}`}
                      >
                        aquí
                      </Link>{" "}
                      (en horario laboral) para que te otorguemos tu primer
                      cupón, el cual corresponde a una tercera parte del monto
                      total.
                    </>
                  }
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={
                    <>
                      4. Una vez con tu cupón, puedes navegar por{" "}
                      <Link href={"https://clupp.tdr.tienda/"}>
                        nuestra tienda
                      </Link>
                      , hasta encontrar algún producto o servicio que te
                      encante.
                    </>
                  }
                />
              </ListItem>
              <ListItem>
                <ListItemText primary="5. Avanza en la tienda, y al momento de pagar podrás usar el cupón, el cual podrá cubrir total o parcialmente el monto a pagar." />
              </ListItem>
              <ListItem>
                <ListItemText primary="6. Dentro de un mes, vuelve a escribirnos para que te demos el siguiente cupón correspondiente a otra tercera parte, sujeto a que tu referido mantenga su seguro activo." />
              </ListItem>
              <ListItem>
                <ListItemText primary="7. Dentro de dos meses, vuelve a escribirnos para que te demos el último cupón correspondiente al monto restante, sujeto a que mantenga su seguro activo para entonces." />
              </ListItem>
            </List>
          }
        />
      </Stack>
      <Stack alignItems="center" spacing={2} marginTop={"20px"}>
        <Typography variant="subtitle1" style={{ userSelect: "none" }}>
          📲 Comparte este QR personalizado, que es único para ti, para referir.
        </Typography>
        <img
          alt="Código QR para referir"
          style={{
            minWidth: "200px",
            maxWidth: "300px",
            borderRadius: "8px",
          }}
          src={`https://api.qrserver.com/v1/create-qr-code/?data=${state.referURL}&size=200x200`}
        />
      </Stack>
      <Stack
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
        marginTop={"30px"}
      >
        <Typography
          variant="subtitle1"
          style={{ userSelect: "none", width: "60%" }}
        >
          🔗 O bien, comparte tu liga única y personalizada para referir, dando
          clic aquí:
        </Typography>
        <Button
          startIcon={canShare ? <Share /> : <WhatsApp />}
          variant="outlined"
          disableElevation
          color={canShare ? "primary" : "success"}
          onClick={handleShare}
          sx={{
            textTransform: "none",
            borderColor: canShare ? "#007BFF" : "#25D366",
            "&:hover": {
              borderColor: canShare ? "#0056b3" : "#1c9d57",
            },
          }}
        >
          Compartir
        </Button>
      </Stack>
    </>
  );
};

export default ReferedProgram;
